export const createOriginalLogoPathFromThumbnailUrl = (thumbnailUrl: string, bucketName: string) => {
  const imageName = thumbnailUrl
    .replace(`https://firebasestorage.googleapis.com/v0/b/${bucketName}/o/uploads%2Fpublic%2F`, '')
    .replace('_400x400?alt=media', '')

  return `uploads/${imageName}`
}
